import { Card, Table, Typography } from 'antd';
import * as React from 'react';
import {
  ListBase, ListProps, useListContext
} from 'react-admin';
import ReactJson from '@microlink/react-json-view';
import {Link} from 'react-router-dom';
import { formatDateAndTime } from '@src/helpers/utils';
import { ApplicationRecord } from '@src/types';
import SkeletonTable, { SkeletonTableColumnsType } from '@src/components/Common/SkeletonTable';
import {onExpandIcon, useExpandableRows} from "@src/components/Common/tableUtils";

const expandedRowRender = (record: ApplicationRecord) => {
  return (
    <Card>
      <ReactJson style={{ padding: '20px' }} src={record.metadata} displayArrayKey={false} displayDataTypes={false} name="meta" displayObjectSize={false} />
    </Card>
  )
}
const ListView = () => {
  const { ids, data, loading, total, setPage, perPage, setPerPage, page } = useListContext();
  const { expandedRowKeys, onExpand, toggleRowExpansion } = useExpandableRows('name');

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Number of Service Items',
      dataIndex: 'num_service_items',
      key: 'num_service_items',
      render: (text: any, record: ApplicationRecord) => <Link to={`/service_items?filter={"application_id":"${record.id}"}`} component={Typography.Link}>{text}</Link>,
    },
    {
      title: 'Pending Change Instances',
      dataIndex: 'num_pending_changes',
      key: 'num_pending_changes',
      render: (text: any, record: ApplicationRecord) => <Link to={`/change_instances?filter={"application_id":"${record.id}","state":"PENDING"}`} component={Typography.Link}>{text}</Link>
    },
    {
      title: 'Approved Change Instances',
      dataIndex: 'num_approved_changes',
      key: 'num_approved_changes',
      render: (text: any, record: ApplicationRecord) => <Link to={`/change_instances?filter={"application_id":"${record.id}","state":"APPROVED"}`} component={Typography.Link}>{text}</Link>
    },
    {
      title: 'Completed Change Instances',
      dataIndex: 'num_completed_changes',
      key: 'num_completed_changes',
      render: (text: any, record: ApplicationRecord) => <Link to={`/change_instances?filter={"application_id":"${record.id}","state":"COMPLETED"}`} component={Typography.Link}>{text}</Link>
    },
    {
      title: 'Last Modified',
      key: 'modified',
      render: (text: any, record: any) => formatDateAndTime(record.modified)
    },
  ]

  const tableData: any[] = []
  ids.forEach(id => {
    tableData.push(data[id])
  });
  return (
    <Card
      bordered={false}
      className="criclebox tablespace mb-24"
    >
      <SkeletonTable loading={loading} columns={columns as SkeletonTableColumnsType[]}>
        <Table
          rowKey="name"
          columns={columns}
          style={{paddingTop: "10px"}}
          pagination={{
            onShowSizeChange: (_current, size) => setPerPage(size),
            showSizeChanger: true,
            pageSizeOptions: [25, 50, 100],
            total: total,
            pageSize: perPage,
            current: page,
            onChange: page => setPage(page),
            className: "pagination-padding",
          }}
          dataSource={tableData}
          expandable={{
            expandedRowRender,
            expandRowByClick: true,
            expandedRowKeys,
            onExpand,
            expandIcon: onExpandIcon(toggleRowExpansion, onExpand),
          }}
          onRow={(record) => { return { onClick: () => { toggleRowExpansion(record.name) } } }}
          locale={{ emptyText: "Applications will display here once a declaration has been sent" }}
        />
      </SkeletonTable>
    </Card>
  )
}

const ApplicationList = (props: ListProps) => {

  return (
    <ListBase perPage={25} {...props} filter={{light: true}}>
      <ListView />
    </ListBase>
  )
}

export default ApplicationList;
